export function makeArrayFromConfig(param) {
    const trimmedParams = param === null || param === void 0 ? void 0 : param.trim();
    if (!trimmedParams) {
        return [''];
    }
    if (trimmedParams === null || trimmedParams === void 0 ? void 0 : trimmedParams.includes(',')) {
        const arr = trimmedParams.split(',').filter((val) => val);
        if (arr.length > 0) {
            return arr;
        }
        return [''];
    }
    return [trimmedParams];
}
